import type { RiskFactor } from '@/portfolio/proposal-builder/types'

import { intrinsicScopeForConfig } from '@/portfolio/proposal-builder/config'
import {
  extractScope,
  hasScope,
} from '@/portfolio/proposal-builder/data/helpers/constraint-scope'
import { eachConstraintInFactor } from '@/portfolio/proposal-builder/data/helpers/each-constraint-in-factor'
import { Priority } from '@/portfolio/proposal-builder/types'
import { mergePriority } from '@/utils/constraints/constraint-priority'

/**
 * Re-derives a factor's aggregate priority and scope from the constraints it
 * currently holds — the inverse of placement's capture, so a removal can't
 * leave a stale value behind for the serializer to stamp onto survivors or the
 * rules view to render.
 *
 * Factor scope is not user-editable; it is captured from ingested constraints
 * and shown read-only. Deriving it purely from the surviving constraints
 * (falling back to the config's intrinsic scope) is therefore always correct.
 */
export function recomputeFactorAggregates(riskFactor: RiskFactor): void {
  let priority: Priority = Priority.Low
  let scope = intrinsicScopeForConfig(riskFactor.configKey)
  eachConstraintInFactor(riskFactor, (constraint) => {
    priority = mergePriority(
      priority,
      constraint.constraint_priority ?? Priority.Low,
    )
    const constraintScope = extractScope(constraint)
    if (hasScope(constraintScope)) {
      scope = constraintScope
    }
  })
  riskFactor.priorityLevel = priority
  riskFactor.scope = scope
}
